import React from 'react'
import Team from '../../components/our_team/Team'

const index = () => {
  return (
    <div>
        <Team />
    </div>
  )
}

export default index